import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Handle chunk load errors (stale cache after deployment)
// This catches errors when old cached JS files are no longer available
window.addEventListener('error', (event) => {
  // Check if it's a script loading error
  if (
    event.message?.includes('Failed to fetch dynamically imported module') ||
    event.message?.includes('Loading chunk') ||
    event.message?.includes('Loading CSS chunk')
  ) {
    console.warn('[Cache] Stale chunk detected, reloading...');
    // Clear caches and reload
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }
    // Force reload without cache
    window.location.reload();
  }
});

// Also handle unhandled promise rejections (for dynamic imports)
window.addEventListener('unhandledrejection', (event) => {
  const message = event.reason?.message || String(event.reason);

  // Only reload for chunk load errors (stale cache after deployment)
  if (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Loading chunk') ||
    message.includes('ChunkLoadError')
  ) {
    console.warn('[Cache] Chunk load failed, reloading...');
    event.preventDefault();
    // Clear caches and reload
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }
    window.location.reload();
  } else {
    // For all other unhandled rejections: log but DON'T reload
    // This prevents page reloads from PDF.js errors, file upload errors, etc.
    console.error('[UnhandledRejection]', message, event.reason);
    event.preventDefault(); // Prevent browser default behavior (which could be a reload)
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
